<template>
  <div class="mt-5">
    <WallPaintRadio :value="room.wall_type" @input="$emit('input', { wall_type: $event })" />

    <!-- Standard color -->
    <div v-if="room.wall_type === 'standard_color'">
      <div class="mt-5 mb-1">
        <span class="text-h6">
          {{ $t("Pick color code from standard colors") }} ({{ forTitle }})
        </span>
        <span class="ml-3" v-if="room.standard_color_code">
          <v-chip outlined small>
            <v-icon left>mdi-check</v-icon>
            {{ colorTitle(room.standard_color_code) }}
          </v-chip>
        </span>
      </div>
      <MandatorySliderSelector
        :id="`rooms.${room.index}.standard_color_code`"
        :error="e(`rooms.${room.index}.standard_color_code`)"
        :error-messages="$t('Please pick color code {0}', [$t('for room walls')])"
        :value="room.standard_color_code"
        :items="$store.state.options.colors"
        @input="$emit('input', { standard_color_code: $event })"
      />
    </div>

    <!-- Custom color code -->
    <div v-else-if="room.wall_type === 'custom_color'">
      <div class="mt-5 mb-1">
        <span class="text-h6">
          <span v-t="'Insert custom color code'" />
        </span>
      </div>

      <base-textarea
        :id="`rooms.${room.index}.custom_color_code`"
        :error="e(`rooms.${room.index}.custom_color_code`)"
        :error-messages="$t('Please insert color code {0}', [$t('for room walls')])"
        :label="$t('Eg. Tikkurila F497 Paper')"
        outlined
        rows="1"
        :value="room.custom_color_code"
        @change="$emit('input', { custom_color_code: $event })"
      />
    </div>

    <div v-else-if="room.wall_type === 'mixed_colors'">
      <div class="mt-5 mb-1">
        <span class="text-h6">
          <span v-t="'Describe your preferences and/or upload drawing'" />
        </span>
      </div>

      <base-textarea
        :id="`rooms.${room.index}.mixed_colors_description`"
        :error="e(`rooms.${room.index}.mixed_colors_description`)"
        :error-messages="$t('Please describe your preferences (or insert file below)')"
        prepend-icon="mdi-text"
        :label="$t('Write down color codes together with instructions')"
        outlined
        rows="4"
        :value="room.mixed_colors_description"
        @change="$emit('input', { mixed_colors_description: $event })"
      />
      <AttachmentsInput
        type="room"
        :type-id="room.id"
        :label="$t('Upload file')"
        hide-details="auto"
      />
    </div>
  </div>
</template>

<script>
import AttachmentsInput from "../AttachmentsInput";
import MandatorySliderSelector from "../MandatorySliderSelector";
import WallPaintRadio from "../WallPaintRadio";

export default {
  components: {
    WallPaintRadio,
    MandatorySliderSelector,
    AttachmentsInput,
  },
  props: {
    room: {
      type: Object,
      required: true,
    },
    forTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    colorTitle(slug) {
      return this.$store.state.options.colors.find((item) => item.slug === slug).title;
    },
    e(key) {
      return this.$store.getters["visibleError"]("WallPaints", key);
    },
  },
};
</script>
